<div id="export-now">Export Now</div>
<div class="input-section">
  <mat-form-field id="report-name">
    <mat-label>Report Name</mat-label>
    <input id="report-name-input" matInput required [formControl]="reportName" (input)="updateReportName()">
    <mat-error id="err" *ngIf="showErrorMessage && !schedulePaneInfo.reportName.length">This is a required field</mat-error>
  </mat-form-field>
</div>
<div class="input-section">
  <div class="helper-text">Check the box below to automatically export this report every month when your new data is
    loaded.
  </div>
  <div>
    <mat-checkbox id="generate-monthly" (change)="updateIsGeneratedMonthly()" [checked]="schedulePaneInfo.isMonthly">
      Generate this report monthly
    </mat-checkbox>
  </div>
</div>
